module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Cooking-pot-c9722124aaa57650e5dac7638d838b2a.svg";